import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MTEK_TRAVEL_MODULE_ID } from "../../configs/module";

export interface TenantCreds {
  domain: string,
  moduleId: string,
  country?: string,
  currency: {
    prefix: string,
    suffix: string
  }
}

const loadFromSession = <T>(key: string, fallback: T): T => {
  try {
    const stored = sessionStorage.getItem(key);
    return stored ? (JSON.parse(stored) as T) : fallback;
  } catch {
    return fallback;
  }
};

const initialState: TenantCreds = loadFromSession<TenantCreds>("tenant-details", {
  domain: "",
  moduleId: MTEK_TRAVEL_MODULE_ID,
  country: "Kenya",
  currency: {
    prefix: "KES",
    suffix: "Ksh"
  },
});

const TenantCredsSlice = createSlice({
  name: "tenantCreds",
  initialState,
  reducers: {
    setTenantHost(state, action: PayloadAction<TenantCreds>) {
      sessionStorage.setItem("tenant-details", JSON.stringify(action.payload));
      return action.payload;
    },

    updateTenantHost(state, action: PayloadAction<Partial<TenantCreds>>) {
      const updated = { ...state, ...action.payload };
      sessionStorage.setItem("tenant-details", JSON.stringify(updated));
      return updated;
    },

    clearTenantHost() {
      sessionStorage.removeItem("tenant-details");
      return {
        domain: "",
        moduleId: MTEK_TRAVEL_MODULE_ID,
        country: "Kenya",
        currency: {
          prefix: "KES",
          suffix: "Ksh"
        }
      };
    },
  },
});

export const tenantHostActions = TenantCredsSlice.actions;

export default TenantCredsSlice;